import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';  // Importar HttpClient
import { DatosService } from '../../services/datos.service';
import { RoutingService } from '../../services/routing.service';

@Component({
  selector: 'app-cal-params',
  templateUrl: './cal-params.component.html',
  styleUrls: ['./cal-params.component.css']
})
export class CalParamsComponent implements OnInit {
  enfermedades: any[] = [];
  active: any;  // Usamos un objeto enfermedad completo para almacenar la enfermedad activa

  constructor(private http: HttpClient, public routes: RoutingService) { }

  ngOnInit() {
    this.getEnfermedades();  // Llamamos a la función para cargar las enfermedades
  }

  // Función para obtener las enfermedades desde el endpoint
  getEnfermedades() {
    const url = 'https://api.calobesidad.innsider.com.co/api/illness-data/';  // URL del endpoint

    this.http.get<any>(url).subscribe(
      (data) => {
        this.enfermedades = [];  // Inicializamos el arreglo de enfermedades

        // Iteramos sobre cada enfermedad en la respuesta
        for (const enfermedad in data) {
          if (data.hasOwnProperty(enfermedad)) {
            const enfermedadData = data[enfermedad];
            const detallesPorGenero = enfermedadData.Detalles_por_genero;

            // Si existen detalles para masculino, femenino o ambos, los agregamos
            if (detallesPorGenero.masculino) {
              this.enfermedades.push({
                nombre: enfermedad,
                sexo: 'Masculino',
                pae: detallesPorGenero.masculino.pae,
                slug: enfermedad // Necesitamos el slug para identificar la enfermedad
              });
            }

            if (detallesPorGenero.femenino) {
              this.enfermedades.push({
                nombre: enfermedad,
                sexo: 'Femenino',
                pae: detallesPorGenero.femenino.pae,
                slug: enfermedad // Necesitamos el slug para identificar la enfermedad
              });
            }

            // Si ambos existe (aunque es null en tu ejemplo), también lo agregamos
            if (detallesPorGenero.ambos) {
              this.enfermedades.push({
                nombre: enfermedad,
                sexo: 'Ambos',
                pae: detallesPorGenero.ambos.pae,
                slug: enfermedad // Necesitamos el slug para identificar la enfermedad
              });
            }
          }
        }

        // Establecer la primera enfermedad como valor predeterminado en el select
        if (this.enfermedades.length > 0) {
          this.active = this.enfermedades[0];  // La enfermedad activa es el primer objeto en el arreglo
        }
      },
      (error) => {
        console.error('Error al obtener las enfermedades:', error);
      }
    );
  }

  // Método para actualizar la enfermedad activa
  updateActive(selected: any): void {
    this.active = selected;  // Actualiza la enfermedad seleccionada
  }
}
